// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1E_F5","footer":"ModalError_footer__r2j3H"};